import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import history from "./APIs/History";
import Login from "./Pages/Login/Login";
import Dashboard from "./Pages/Dashboard/Dashboard";
import PortalChooser from "./Pages/PortalChooser/PortalChooser";
import FourOFour from "./Pages/FourOFour/FourOFour";
import SnackbarProvider from 'react-simple-snackbar'
import ErrorBoundry from "./Helpers/ErrorBoundry/ErrorBoundry"
import RatesHistory from "./Pages/RatesHistory/RatesHistory";
import Accounting from "./Pages/Accounting/Accounting";
import "./App.css";

class App extends Component {
  constructor() {
    super();
    this.state = {};
  }
  // localStorage.getItem("userData")
  //This is passed to login who will set the userData state with the data returned from the authentication api then passed on via context to any component that needs it

  render() {
    return (

      <SnackbarProvider>
        <ErrorBoundry>
          <div className="App">
            <div className="container">
              <Router history={history}>
                <Switch>
                  <Route exact path="/" render={() => <Login />} />

                  <Route exact path="/Login" render={() => <Login />} />

                  <Route exact path="/Dashboard" render={() => <Dashboard />} />

                  <Route exact path="/PortalChooser" render={() => <PortalChooser />} />

                  <Route exact path="/History" render={() => <RatesHistory />} />

                  <Route exact path="/Accounting" render={() => <Accounting />} />

                  {/* <Route exact path="/Error" render={() => <ErrorBoundry />} /> */}

                  <Route component={FourOFour} />
                </Switch>
              </Router>
            </div>
          </div>
        </ErrorBoundry>
      </SnackbarProvider>

    );
  }
}

export default App;
